import React from 'react';

const Input = ({ 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  className = '', 
  icon,
  iconPosition = 'left',
  ...props 
}) => {
  const baseStyles = 'form-input flex w-full resize-none overflow-hidden rounded-lg border border-gray-300 dark:border-gray-600 bg-background-light dark:bg-gray-700 text-text-light-primary dark:text-text-dark-primary placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:border-primary focus:ring-primary focus:outline-none';
  
  const inputClasses = icon 
    ? iconPosition === 'left' 
      ? 'pl-10 pr-4' 
      : 'pl-4 pr-10'
    : 'px-4';
  
  const classes = `${baseStyles} ${inputClasses} ${className}`;
  
  return (
    <div className="relative">
      {icon && iconPosition === 'left' && (
        <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
          {icon}
        </span>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={classes}
        {...props}
      />
      {icon && iconPosition === 'right' && (
        <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
          {icon}
        </span>
      )}
    </div>
  );
};

export default Input;

